import {BaseModuleState} from "../../../infrastructure/models/base-module-state";
import {computed} from "mobx";
import {BaseMobxState} from "../../../infrastructure/mobx/base-mobx-state";
import {AppStore} from "../../../core/app/app-store";
import {LoggerUtils} from "../../../infrastructure/utils/logger/logger-utils";
import {DatetimeUtils} from "../../../infrastructure/utils/datetime-utils";
import {DeviceViewModel} from "../../../core/models/device.view-model";
import {TermsUtils} from "../../../infrastructure/utils/terms-utils";
import {NavigationManager} from "../../../core/managers/navigation-manager";
import {PromotedSponsorshipModuleConfig} from "../promoted-sponsorship-module.config";
import {ROUTE_NAMES} from "../../../core/consts";
import {SponsorshipViewModel} from "../../../domain/sponsorships/models/sponsorship.view-model";
import {singleton} from "../../../infrastructure/decorators/singleton";

@singleton
export class PromotedSponsorshipModuleState extends BaseModuleState {
  static injectables = [...BaseMobxState.injectables, NavigationManager, AppStore, LoggerUtils, DatetimeUtils, DeviceViewModel, TermsUtils, PromotedSponsorshipModuleConfig];

  @computed get sponsorship(): SponsorshipViewModel {
    const vm: SponsorshipViewModel = this.hasSponsorships && new SponsorshipViewModel(this.dataSource?.sponsorships?.first(), this.device.isSmallView, true);

    return vm;
  }

  @computed get isPopulatedByRoute(): Boolean {
    if(!this.currentLinkModel) {
      return false;
    }

    const routes = [ROUTE_NAMES.allScores, ROUTE_NAMES.myScoresPage];

    return routes.includes(this.currentLinkModel.name);
  }

  @computed get hasSponsorships(): Boolean {
    const hasSponsorships = this.dataSource && this.dataSource.sponsorships && this.dataSource.sponsorships.length > 0;

    return hasSponsorships;
  }
  @computed get isVisible(): Boolean {
    return this.isPopulatedByRoute && this.hasSponsorships;
  }

  get isPopulated(): Boolean {
    return this.isVisible;
  }
}
